<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>用户管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-row>
      <el-button type="primary"
                 @click="dialogVisible = true">添加消息
      </el-button>
      <br/><br/>
    </el-row>
    <layout-panel :show-header="false">
      <el-table :data="table"
                stripe
                highlight-current-row
                style="width: 100%">
        <el-table-column prop="id"
                         label="id"></el-table-column>
        <el-table-column prop="title"
                         label="消息标题">
          <template slot-scope="scope">
            <span style="cursor:pointer;color:rgb(88,157,248)"
                  @click="showDetail(scope.row)">{{scope.row.title}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="masway"
                         label="发送方式">
          <template slot-scope="scope">
            <span v-for="value in options.masTypes"
                  v-if="value.id === scope.row.masway">{{value.keyword}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sendTo"
                         label="发送至"></el-table-column>
        <el-table-column prop="admin_name"
                         label="发送人"></el-table-column>
        <el-table-column prop="created_at"
                         label="发送时间"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
    <el-dialog title="群发消息"
               :visible.sync="dialogVisible"
               width="50%">
      <el-form ref="form"
               :model="form"
               label-width="80px"
               size="medium"
               :rules="searchMasRules"
               @keyup.enter.native="onAddUserMas()">
        <el-form-item label="群发方式"
                      prop="masway">
          <el-select v-model="form.masway"
                     placeholder="请选择结算时间">
            <el-option :label="masType.keyword"
                       :value="masType.id"
                       :key="index"
                       v-for="(masType,index) in options.masTypes"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="form.masway === 2">
          <el-form-item label="添加地区"
                        prop="areaString">
            <el-cascader :options="options.area"
                         @active-item-change="handleItemChange"
                         :props="props"
                         @change="handleItemSelect"
                         :value="areaData"
                         clearable></el-cascader>
            <el-button @click="onAddCity()"
                       type="primary"
                       size="mini">添加
            </el-button>
            <el-button @click="onRemoveCity()"
                       type="danger"
                       size="mini">清空
            </el-button>
            <el-input disabled
                      type="textarea"
                      v-model="form.areaString"></el-input>
          </el-form-item>
        </template>
        <template v-if="form.masway === 3">
          <el-form-item label="选择卖场"
                        prop="markets">
            <el-select v-model="form.markets"
                       multiple
                       filterable
                       remote
                       reserve-keyword
                       placeholder="请输入关键词"
                       :remote-method="remoteMethod"
                       :loading="selectLoading">
              <el-option v-for="item in options.markets"
                         :key="item.id"
                         :label="item.marketname"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="form.masway === 4">
          <el-form-item label="选择标签"
                        prop="labels">
            <el-select v-model="form.labels"
                       multiple
                       filterable
                       remote
                       reserve-keyword
                       placeholder="请输入关键词"
                       :remote-method="remoteLabelMethod"
                       :loading="selectLoading">
              <el-option v-for="item in options.labels"
                         :key="item.id"
                         :label="item.tagname"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="消息标题"
                      prop="title">
          <el-input v-model="form.title"
                    placeholder="(输入系统推送与站内信标题，限30字)"></el-input>
        </el-form-item>
        <el-form-item label="消息内容"
                      prop="content">
          <el-input type="textarea"
                    autosize
                    placeholder="(输入消息内容,限300字)"
                    v-model="form.content"
                    @keyup.enter.stop.native></el-input>
        </el-form-item>
        <el-form-item label="添加图片"
                      prop="img_url">
          <el-upload :limit="1"
                     :on-change="onChangeFile"
                     list-type="picture-card"
                     :on-remove="handleRemove"
                     :on-preview="handlePictureCardPreview"
                     ref="upload"
                     action=""
                     :auto-upload="false">
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog :visible.sync="imgDialogVisible">
            <img width="100%"
                 :src="form.img"
                 alt="爱零工">
          </el-dialog>
        </el-form-item>
        <el-form-item label="图片标题"
                      prop="img_title">
          <el-input v-model="form.img_title"
                    placeholder="(输入图片标题，限30字)"></el-input>
        </el-form-item>
        <el-form-item label="链接地址"
                      prop="link">
          <el-input v-model="form.link"
                    placeholder="(输入链接地址)"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="onAddUserMas()"
                   v-if="formVisible"
                   size="mini">发送</el-button>
        <el-button @click="dialogVisible = false"
                   size="mini">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog title="群发消息详情"
               :visible.sync="masDetailVisible"
               width="50%">
      <el-form ref="formDetail"
               :model="masDetail"
               label-width="80px"
               size="medium">
        <el-form-item label="消息标题"
                      prop="title">{{masDetail.title}}
        </el-form-item>
        <el-form-item label="消息内容"
                      prop="content">{{masDetail.content}}
        </el-form-item>
        <el-form-item label="发送图片"
                      prop="img_url">
          <a :href="masDetail.img_url"
             target="_Blank"
             v-if="masDetail.img_url">
            <img width="100px;"
                 :src="masDetail.img_url?masDetail.img_url+'?x-oss-process=image/resize,w_100/auto-orient,1':null"
                 alt="爱零工">
          </a>
        </el-form-item>
        <el-form-item label="图片标题"
                      prop="img_title">{{masDetail.img_title}}
        </el-form-item>
        <el-form-item label="链接地址"
                      prop="link">{{masDetail.link}}
        </el-form-item>
        <el-form-item label="发送方式"
                      prop="masway">
          <span v-for="masType in options.masTypes"
                v-if="masType.id === masDetail.masway ">
            {{masType.keyword}}
          </span>
        </el-form-item>
        <el-form-item label="发送至"
                      prop="type">{{masDetail.sendTo}}
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import table from '@/mixins/table-v1'
import dateTimePicker from '@core/mixins/dateTimePicker'
import selectRemote from '@core/mixins/selectRemote'
import { searchMasRules } from '../users.rules.js'

export default {
  mixins: [table, dateTimePicker, selectRemote],
  data () {
    return {
      searchMasRules,
      dialogVisible: false,
      imgDialogVisible: false,
      masDetailVisible: false,
      formVisible: true,
      areaData: [],
      selectCitys: [],
      selectOptionName: null,
      // 表格数据
      table: [],
      selectLoading: false,
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      masDetail: {
        masway: 1,
        title: null,
        content: null,
        img_title: null,
        img_url: [],
        link: null,
        sendTo: null,
      },
      form: {
        masway: 1,
        area: [],
        areaString: '',
        markets: [],
        labels: [],
        title: null,
        content: null,
        img_title: null,
        // img: [],
        img_url: [],
        link: null,
      },
      options: {
        masTypes: [
          {id: 1, keyword: '全部用户'},
          {id: 2, keyword: '选择地区'},
          {id: 3, keyword: '选择超市'},
          {id: 4, keyword: '选择标签'},
        ],
        area: [],
        markets: [],
        labels: [],
      },
      props: {
        label: 'name',
        value: 'id',
        children: 'cities',
      },
    }
  },
  computed: Vuex.mapState({}),
  created () {
    this.getProvinceList()
  },
  methods: {
    ...Vuex.mapActions(['getMasTable', 'getProvinceList', 'getCityList', 'getMarketInfo', 'uploadUserMasImg', 'getAreaList', 'getTagInfo',
    ]),
    handleRemove (file, fileList) {
      this.form.img_url = []
    },
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('getMasTable', params)
    },
    handleItemChange (val) {
      // 如果加载过一遍不再重复加载
      let replaceArea = []
      if (val.length === 1) {
        replaceArea = this.options.area
      } else if (val.length === 2) {
        replaceArea = this.options.area[this.selectCitys[0]].cities
      } else {
        return false
      }
      for (let key of Object.keys(replaceArea)) {
        if (replaceArea[key].id === val[val.length - 1]) {
          this.selectCitys[val.length - 1] = parseInt(key)
          if (val.length === 1) {
            this.selectOptionName = replaceArea[key].name
            this.areaData = []
            this.areaData.push(val[val.length - 1])
          } else {
            this.selectOptionName = this.options.area[this.selectCitys[0]].name + '/' + replaceArea[key].name
            this.areaData.splice(1, 1)
            this.areaData.push(val[1])
          }
        }
      }

      if (replaceArea[this.selectCitys[val.length - 1]].id === val[val.length - 1] && replaceArea[this.selectCitys[val.length - 1]].cities.length > 0) {
        return false
      }
      if (val.length === 1) {
        request.common('getCityList', val[val.length - 1]).then(({data}) => {
          for (let i = 0; i < this.options.area.length; i++) {
            if (this.options.area[i].id === val[0]) {
              this.options.area[i].cities = []
              for (let n = 0; n < data.length; n++) {
                this.options.area[i].cities.push({id: data[n].id, name: data[n].name, cities: []})
              }
            }
          }
        })
      } else if (val.length === 2) {
        request.common('getAreaList', val[val.length - 1]).then(({data}) => {
          if (data.length > 0) {
            for (let i = 0; i < this.options.area[this.selectCitys[0]].cities.length; i++) {
              this.options.area[this.selectCitys[0]].cities[i].cities = []
              if (this.options.area[this.selectCitys[0]].cities[i].id === val[1]) {
                for (let n = 0; n < data.length; n++) {
                  this.options.area[this.selectCitys[0]].cities[i].cities.push({id: data[n].id, name: data[n].name})
                }
              }
            }
          }
        })
      }
    },
    getProvinceList () {
      request.page('getProvinceList').then(({data}) => {
        for (let i = 0; i < data.length; i++) {
          this.options.area.push({id: data[i].id, name: data[i].name, cities: []})
        }
      })
    },
    handleItemSelect (val) {
      if (val.length > 0) {
        this.areaData = val
        let children = this.options.area[this.selectCitys[0]].cities[this.selectCitys[1]].cities
        for (let i = 0; i < children.length; i++) {
          if (children[i].id === val[val.length - 1]) {
            this.selectOptionName = this.selectOptionName + '/' + children[i].name
          }
        }
      }
    },
    onAddCity () {
      if (this.selectOptionName === null) {
        this.$message.error('请选择地区后添加！')
        return false
      }
      this.form.area.push(this.areaData[this.areaData.length - 1])
      this.areaData = []
      this.form.areaString += this.selectOptionName + ' ; '
      this.selectCitys = []
      this.selectOptionName = null
    },
    onAddUserMas () {
      this.formVisible = false
      let detail = []
      if (this.form.masway === 1) {
        detail = {
          masway: 1,
          title: this.form.title,
          content: this.form.content,
          img_title: this.form.img_title,
          img_url: this.form.img_url[0],
          link: this.form.link,
        }
      } else if (this.form.masway === 2) {
        detail = {
          masway: 2,
          area: this.form.area,
          title: this.form.title,
          content: this.form.content,
          img_title: this.form.img_title,
          img_url: this.form.img_url[0],
          link: this.form.link,
        }
        if (this.form.area.length <= 0) {
          this.$message.error('请至少选择一个地区')
          this.formVisible = true
          return false
        }
      } else if (this.form.masway === 3) {
        detail = {
          masway: 3,
          markets: this.form.markets,
          title: this.form.title,
          content: this.form.content,
          img_title: this.form.img_title,
          img_url: this.form.img_url[0],
          link: this.form.link,
        }
        if (this.form.markets.length <= 0) {
          this.$message.error('请至少选择一个卖场')
          this.formVisible = true
          return false
        }
      } else if (this.form.masway === 4) {
        detail = {
          masway: 4,
          title: this.form.title,
          content: this.form.content,
          img_title: this.form.img_title,
          img_url: this.form.img_url[0],
          link: this.form.link,
          labels: this.form.labels,
        }
        if (this.form.labels.length <= 0) {
          this.$message.error('请至少选择一个标签')
          this.formVisible = true
          return false
        }
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          return request.common('addUserMas', detail).then((data) => {
            // this.form.img_url = []
            this.$refs['form'].resetFields()
            this.$refs.upload.clearFiles()
            this.onSearch()
            this.formVisible = true
            this.dialogVisible = false
            this.$message({
              showClose: true,
              message: '添加成功',
              type: 'success',
            })
          })
        } else {
          this.$message.error('提交内容填写不正确！')
          this.formVisible = true
        }
      })
    },
    onRemoveCity () {
      this.areaData = []
      this.selectCitys = []
      this.selectOptionName = null
      this.form.area = []
      this.form.areaString = ''
    },
    remoteMethod (query) {
      this.selectRemoteMethod(query, this.getMarketInfo, ({data}) => {
        this.options.markets = data
      })
    },
    remoteLabelMethod (query) {
      this.selectRemoteMethod(query, this.getTagInfo, ({data}) => {
        this.options.labels = data
      })
    },
    onChangeFile (file, fileList) {
      let isExcel = ((file.raw.type === 'image/jpeg') || (file.raw.type === 'image/png'))
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isExcel) {
        this.$message.error('请上传jpg/jpeg/png图片!')
        this.$refs.upload.clearFiles()
        return false
      }
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.$refs.upload.clearFiles()
        return false
      }
      this.OnUploadFile(file.raw)
    },
    OnUploadFile (file) {
      let formData = new FormData()
      formData.append('pic', file)
      return request.common('uploadUserMasImg', formData).then(({data}) => {
        this.form.img_url = []
        this.form.img_url.push(data)
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
      })
    },
    handlePictureCardPreview (file) {
      this.form.img = file.url
      this.imgDialogVisible = true
    },
    showDetail (row) {
      // 直接从前端列表里取，后端redis lrange存储不易取
      filter.setLoop(this.masDetail, row)
      this.$nextTick(() => {
        this.masDetailVisible = true
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/views/users/pages/UsersMasTable.vue